module.exports = class Totals {

    constructor(data) {
        this.data = data.hasOwnProperty('totals') ? data.totals : {};
    }

    get subTotal(){
        return this.data.hasOwnProperty('subTotal') ? this.data.subTotal : 0;
    }

    get total(){
        return this.data.hasOwnProperty('total') ? this.data.total : 0;
    }

    get totalWithoutDisc(){
        return this.data.hasOwnProperty('total_without_disc') ? this.data.total_without_disc : 0;
    }

    get shipping(){
        return this.data.hasOwnProperty('shipping') ? this.data.shipping : null;
    }

    get payment(){
        return this.data.hasOwnProperty('payment') ? this.data.payment : null;
    }

    get frozenFee(){
        return this.data.hasOwnProperty('frozenFee') ? this.data.frozenFee : null;
    }

    get grandTotal(){
        return this.data.hasOwnProperty('grandTotal') ? this.data.grandTotal : 0;
    }

    get points(){
        return this.data.hasOwnProperty('prozisPoints') ? this.data.prozisPoints : 0;
    }

    get couponDiscount(){
        return this.data.hasOwnProperty('couponDiscount') ? this.data.couponDiscount : null;
    }

    get couponSavings(){
        return this.data.hasOwnProperty('couponSavings') ? this.data.couponSavings : null;
    }

}